/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Gym_Limit_ReachedInputs */

const en_us2_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can save up to ${i?.max} gyms. Delete one first.`)
};

const pt_br2_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você pode salvar até ${i?.max} academias. Exclua uma antes.`)
};

const es_419_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes guardar hasta ${i?.max} gimnasios. Elimina uno primero.`)
};

const pt_pt2_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podes guardar até ${i?.max} ginásios. Elimina um primeiro.`)
};

const fr_fr2_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu peux enregistrer jusqu'à ${i?.max} salles. Supprimes-en une d'abord.`)
};

const de_de2_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst bis zu ${i?.max} Studios speichern. Lösch zuerst eins.`)
};

const it_it2_gym_limit_reached = /** @type {(inputs: Gym_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puoi salvare fino a ${i?.max} palestre. Eliminane una prima.`)
};

/**
* | output |
* | --- |
* | "You can save up to {max} gyms. Delete one first." |
*
* @param {Gym_Limit_ReachedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_limit_reached = /** @type {((inputs: Gym_Limit_ReachedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Limit_ReachedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_limit_reached(inputs)
	if (locale === "es-419") return es_419_gym_limit_reached(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_limit_reached(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_limit_reached(inputs)
	if (locale === "de-DE") return de_de2_gym_limit_reached(inputs)
	if (locale === "it-IT") return it_it2_gym_limit_reached(inputs)
	return en_us2_gym_limit_reached(inputs)
});
export { gym_limit_reached as "gym.limit_reached" }